import styled from 'styled-components';

export const Legend = styled.div`
  position: fixed;
  bottom: 60px;
  left: 0;
  z-index: 2;
  background: #000;
  width: 100%;
  height: 0;
  text-align: center;
`;

export const LegendInner = styled.div`
  background: #000;
  display: inline-block;
  max-width: 320px;
  height: 11px;
  background: linear-gradient(90deg, ${props => props.colors.toString()});
  border-radius: 50%;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.12);
  text-align: center;
  width: 100%;
`;

export const LegendBadge = styled.div`
  display: inline-block;
  color: #fff;
  padding: 2px 7px;
  background: rgba(0, 0, 0, 1);
  font-size: 9px;
  position: relative;
  top: -6px;
`;
